import { render, staticRenderFns } from "./YourCornerHBF.vue?vue&type=template&id=4e6ba236&scoped=true"
import script from "./YourCornerHBF.vue?vue&type=script&lang=js"
export * from "./YourCornerHBF.vue?vue&type=script&lang=js"
import style0 from "./YourCornerHBF.vue?vue&type=style&index=0&id=4e6ba236&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e6ba236",
  null
  
)

export default component.exports